export const EMAIL = process.env.REACT_APP_AUTH_EMAIL;
export const PASSWORD = process.env.REACT_APP_AUTH_PASSWORD;